import styled from 'styled-components';

import { SkeletonRow } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

export const Identity = styled(SkeletonRow)`
    justify-content: flex-start;
`;
